(function () {
  'use strict';

  var RUNTIME_KEY = '__kkUpcomingNewCarouselRuntime';
  var ROOT_SELECTOR = '[data-kk-upcoming-new]';
  var CARD_SELECTOR = '[data-kk-upcoming-card]';
  var ENTRANCE_DELAY = 2000;
  var ENTRANCE_DURATION = 1300;
  var AUTO_DELAY = 3600;
  var INTERACTION_RESUME_DELAY = 5000;
  var AUTO_DURATION = 1200;
var SNAP_DURATION = 380;
var POINTER_INTENT_THRESHOLD = 3;
var VERTICAL_INTENT_THRESHOLD = 30;
var HORIZONTAL_INTENT_RATIO = 0.2;
var VERTICAL_INTENT_RATIO = 4.5;
var SWIPE_DISTANCE_MIN = 45;
var SWIPE_DISTANCE_MAX = 55;
var FLICK_VELOCITY = 0.35;
var VELOCITY_SAMPLE_WINDOW = 110;
  var controllers = new WeakMap();

  function modulo(value, length) {
    return ((value % length) + length) % length;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function recordPointerSample(pointer, x, time) {
    pointer.samples.push({
      x: x,
      time: time
    });

    pointer.samples = pointer.samples.filter(function (sample) {
      return time - sample.time <= VELOCITY_SAMPLE_WINDOW;
    });
  }

  function getPointerVelocity(pointer) {
    var firstSample;
    var lastSample;
    var elapsed;

    if (pointer.samples.length < 2) {
      return 0;
    }

    firstSample = pointer.samples[0];
    lastSample = pointer.samples[pointer.samples.length - 1];
    elapsed = lastSample.time - firstSample.time;

    return elapsed > 0 ? (lastSample.x - firstSample.x) / elapsed : 0;
  }

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function getReleaseTimestamp(card) {
    var timestamp = parseInt(card.getAttribute('data-kk-release-timestamp'), 10);
    return isFinite(timestamp) ? timestamp : 0;
  }

  function compareCards(cardA, cardB) {
    var statusA = cardA.getAttribute('data-kk-launch-status');
    var statusB = cardB.getAttribute('data-kk-launch-status');
    var timestampA = getReleaseTimestamp(cardA);
    var timestampB = getReleaseTimestamp(cardB);

    if (statusA !== statusB) {
      return statusA === 'future' ? -1 : 1;
    }

    return statusA === 'future'
      ? timestampA - timestampB
      : timestampB - timestampA;
  }

  function setReleasedState(root, card) {
    var badge = card.querySelector('[data-kk-status-badge]');
    var cta = card.querySelector('[data-kk-status-cta] span:first-child');
    var countdown = card.querySelector('[data-grid-launch-countdown]');

    card.setAttribute('data-kk-launch-status', 'new');
    card.classList.remove('is-future', 'is-featured');
    card.classList.add('is-new');

    if (badge) {
      badge.textContent = root.getAttribute('data-new-badge') || 'UUTUUS';
    }

    if (cta) {
      cta.textContent = root.getAttribute('data-buy-now-text') || 'Osta nyt';
    }

    if (countdown) {
      countdown.hidden = true;
      countdown.setAttribute('aria-hidden', 'true');
    }
  }

  function sortCards(root) {
    var track = root.querySelector('[data-kk-upcoming-track]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR)) : [];
    var now = Math.floor(Date.now() / 1000);
    var firstFutureFound = false;

    cards.forEach(function (card) {
      if (
        card.getAttribute('data-kk-launch-status') === 'future' &&
        getReleaseTimestamp(card) <= now
      ) {
        setReleasedState(root, card);
      }
      card.classList.remove('is-featured');
    });

    cards.sort(compareCards);

    cards.forEach(function (card) {
      if (!firstFutureFound && card.getAttribute('data-kk-launch-status') === 'future') {
        card.classList.add('is-featured');
        firstFutureFound = true;
      }
      track.appendChild(card);
    });

    root.classList.toggle('has-future-products', firstFutureFound);
    root.classList.toggle('has-new-products-only', !firstFutureFound);

    return cards;
  }

  function CarouselController(root) {
    var desktopVisibleCards = parseInt(root.getAttribute('data-desktop-visible'), 10);
    var mobileVisibleCards = parseInt(root.getAttribute('data-mobile-visible'), 10);

    this.root = root;
    this.carousel = root.querySelector('[data-kk-upcoming-carousel]');
    this.viewport = root.querySelector('[data-kk-upcoming-viewport]');
    this.track = root.querySelector('[data-kk-upcoming-track]');
    this.toggle = root.querySelector('[data-kk-upcoming-autoplay-toggle]');
    this.toggleLabel = root.querySelector('[data-kk-upcoming-autoplay-label]');
    this.liveRegion = root.querySelector('[data-kk-upcoming-live]');
    this.cards = [];
    this.position = 0;
    this.activeIndex = -1;
    this.autoTimer = null;
    this.entranceTimer = null;
    this.animationFrame = null;
    this.resizeTimer = null;
    this.suppressClickUntil = 0;
    this.userPaused = false;
    this.focusWithin = false;
    this.dragging = false;
    this.pointer = null;
    this.visibilityObserver = null;
    this.sectionVisible = false;
    this.entranceStarted = false;
    this.entranceComplete = false;
    this.destroyed = false;
    this.cleanup = [];
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mobileView = window.matchMedia('(max-width: 720px)');
    this.desktopVisibleCards = [5, 7, 9].indexOf(desktopVisibleCards) !== -1
      ? desktopVisibleCards
      : 5;
    this.mobileVisibleCards = mobileVisibleCards === 3 ? 3 : 1;
    this.pauseLabel = this.carousel ? this.carousel.getAttribute('data-pause-label') : '';
    this.playLabel = this.carousel ? this.carousel.getAttribute('data-play-label') : '';
    this.itemLabel = this.carousel ? this.carousel.getAttribute('data-item-label') : '';
  }

  CarouselController.prototype.listen = function (target, type, callback, options) {
    if (!target || !target.addEventListener) {
      return;
    }

    target.addEventListener(type, callback, options);
    this.cleanup.push(function () {
      target.removeEventListener(type, callback, options);
    });
  };

  CarouselController.prototype.init = function () {
    var controller = this;

    if (!this.carousel || !this.viewport || !this.track) {
      return false;
    }

    this.cards = sortCards(this.root);
    if (!this.cards.length) {
      return false;
    }

    this.entranceComplete = this.cards.length < 2 || this.reducedMotion.matches;
    this.position = this.entranceComplete ? 0 : this.cards.length - 1;

    this.root.setAttribute('data-kk-upcoming-initialized', 'true');
    this.carousel.setAttribute('data-kk-upcoming-carousel-initialized', 'true');
    this.root.classList.add('is-carousel-ready');
    this.root.classList.toggle('is-awaiting-entrance', !this.entranceComplete);

    this.cards.forEach(function (card) {
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', 'slide');
      card.querySelectorAll('img').forEach(function (image) {
        image.setAttribute('draggable', 'false');
      });
    });

    this.listen(this.toggle, 'click', function () {
      controller.beginInteraction();
      controller.userPaused = !controller.userPaused;
      controller.updateToggle();
      if (controller.userPaused) {
        controller.clearAutoTimer();
      } else {
        controller.scheduleAuto(INTERACTION_RESUME_DELAY);
      }
    });

    this.listen(this.viewport, 'keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
      }

      event.preventDefault();
      controller.pauseAutoAfterInteraction();
      controller.moveBy(event.key === 'ArrowRight' ? 1 : -1, true);
    });

    this.listen(this.carousel, 'focusin', function () {
      controller.beginInteraction();
      controller.focusWithin = true;
      controller.clearAutoTimer();
    });

    this.listen(this.carousel, 'focusout', function () {
      window.setTimeout(function () {
        controller.focusWithin = controller.carousel.contains(document.activeElement);
        if (!controller.focusWithin) {
          controller.scheduleAuto(INTERACTION_RESUME_DELAY);
        }
      }, 0);
    });

    this.listen(this.viewport, 'pointerdown', function (event) {
      controller.onPointerDown(event);
    });
    this.listen(this.viewport, 'pointermove', function (event) {
      controller.onPointerMove(event);
    }, { passive: false });
    this.listen(this.viewport, 'pointerup', function (event) {
      controller.onPointerEnd(event, false);
    });
    this.listen(this.viewport, 'pointercancel', function (event) {
      controller.onPointerEnd(event, true);
    });

    this.listen(this.viewport, 'click', function (event) {
      controller.onClick(event);
    }, true);

    this.listen(this.viewport, 'dragstart', function (event) {
      event.preventDefault();
    });

    this.listen(document, 'visibilitychange', function () {
      if (document.hidden) {
        controller.clearAutoTimer();
        if (!controller.entranceComplete) {
          controller.resetPendingEntrance();
        } else {
          controller.pauseActiveAnimation();
        }
      } else if (!controller.entranceComplete && controller.sectionVisible) {
        controller.startEntrance();
      } else {
        controller.scheduleAuto(INTERACTION_RESUME_DELAY);
      }
      controller.root.setAttribute(
        'data-kk-motion-paused',
        (document.hidden || !controller.sectionVisible || controller.reducedMotion.matches) ? 'true' : 'false'
      );
    });

    this.listen(window, 'resize', function () {
      window.clearTimeout(controller.resizeTimer);
      controller.resizeTimer = window.setTimeout(function () {
        controller.measure();
        controller.render(true);
      }, 120);
    });

    var motionChange = function () {
      if (controller.reducedMotion.matches) {
        controller.clearAutoTimer();
        controller.clearEntranceTimer();
        controller.cancelAnimation();
        controller.position = 0;
        controller.finishEntrance();
      }
      controller.updateToggle();
      controller.measure();
      controller.render(true);
      if (!controller.reducedMotion.matches && !controller.entranceComplete) {
        controller.startEntrance();
      } else if (!controller.reducedMotion.matches) {
        controller.scheduleAuto(INTERACTION_RESUME_DELAY);
      }
      controller.root.setAttribute(
        'data-kk-motion-paused',
        (document.hidden || !controller.sectionVisible || controller.reducedMotion.matches) ? 'true' : 'false'
      );
    };

    if (this.reducedMotion.addEventListener) {
      this.listen(this.reducedMotion, 'change', motionChange);
    } else if (this.reducedMotion.addListener) {
      this.reducedMotion.addListener(motionChange);
      this.cleanup.push(function () {
        controller.reducedMotion.removeListener(motionChange);
      });
    }

    this.listen(this.root, 'kk:grid-launch-expired', function (event) {
      var card = event.target.closest(CARD_SELECTOR);
      if (!card || !controller.root.contains(card)) {
        return;
      }
      setReleasedState(controller.root, card);
      controller.refresh(card);
    });

    this.cards.forEach(function (card) {
      card.querySelectorAll('img').forEach(function (image) {
        if (!image.complete) {
          controller.listen(image, 'load', function () {
            controller.measure();
            controller.render(true);
          }, { once: true });
        }
      });
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!controller.destroyed) {
          controller.measure();
          controller.render(true);
        }
      });
    }

    this.updateToggle();
    this.measure();
    this.render(true);
    window.requestAnimationFrame(function () {
      if (!controller.destroyed) {
        controller.measure();
        controller.render(true);
      }
    });
    this.setupVisibilityObserver();

    return true;
  };

  CarouselController.prototype.getRelativeOffset = function (cardIndex) {
    var count = this.cards.length;
    var rawOffset;
    var offset;

    if (count < 2) {
      return 0;
    }

    rawOffset = cardIndex - this.position;
    offset = modulo(rawOffset + count / 2, count) - count / 2;

    if (count % 2 === 0 && Math.abs(offset + count / 2) < 0.0001 && rawOffset > 0) {
      offset = count / 2;
    }

    return offset;
  };

  CarouselController.prototype.getLayoutConfig = function () {
    if (this.mobileView.matches) {
      if (this.mobileVisibleCards === 3) {
        return {
          visibleHalf: 1,
          firstStepFactor: 0.46,
          followingStepFactor: 0.38,
          scaleStep: 0.17,
          minimumScale: 0.66,
          rotationStep: 16,
          maximumRotation: 24,
          depthStep: 145
        };
      }

      return {
        visibleHalf: 1,
        firstStepFactor: 0.72,
        followingStepFactor: 0.54,
        scaleStep: 0.18,
        minimumScale: 0.62,
        rotationStep: 18,
        maximumRotation: 24,
        depthStep: 150
      };
    }

    if (this.desktopVisibleCards === 9) {
      return {
        visibleHalf: 4,
        firstStepFactor: 0.14,
        followingStepFactor: 0.1,
        scaleStep: 0.09,
        minimumScale: 0.62,
        rotationStep: 13,
        maximumRotation: 44,
        depthStep: 115
      };
    }

    if (this.desktopVisibleCards === 7) {
      return {
        visibleHalf: 3,
        firstStepFactor: 0.18,
        followingStepFactor: 0.13,
        scaleStep: 0.115,
        minimumScale: 0.62,
        rotationStep: 18,
        maximumRotation: 42,
        depthStep: 145
      };
    }

    return {
      visibleHalf: 2,
      firstStepFactor: 0.255,
      followingStepFactor: 0.195,
      scaleStep: 0.155,
      minimumScale: 0.62,
      rotationStep: 27,
      maximumRotation: 40,
      depthStep: 185
    };
  };

  CarouselController.prototype.getCardTransform = function (offset) {
    var absoluteOffset = Math.abs(offset);
    var direction = offset < 0 ? -1 : 1;
    var viewportWidth = this.viewport.clientWidth || 1200;
    var mobile = this.mobileView.matches;
    var reduced = this.reducedMotion.matches;
    var layout = this.getLayoutConfig();
    var visibilityLimit = layout.visibleHalf + 0.58;
    var fadeStart = layout.visibleHalf;
    var fadeDistance = Math.max(0.01, visibilityLimit - fadeStart);
    var firstStep = viewportWidth * layout.firstStepFactor;
    var followingStep = viewportWidth * layout.followingStepFactor;
    var x = absoluteOffset <= 1
      ? firstStep * absoluteOffset
      : firstStep + followingStep * (absoluteOffset - 1);
    var scale = Math.max(layout.minimumScale, 1 - absoluteOffset * layout.scaleStep);
    var rotate = reduced
      ? 0
      : -direction * Math.min(layout.maximumRotation, absoluteOffset * layout.rotationStep);
    var depth = reduced ? 0 : -absoluteOffset * layout.depthStep;
    var opacity = absoluteOffset <= fadeStart
      ? 1
      : Math.max(0, Math.min(1, (visibilityLimit - absoluteOffset) / fadeDistance));
    var infoOpacity;

    if (mobile) {
      infoOpacity = absoluteOffset < 0.48 ? 1 : 0;
    } else {
      infoOpacity = Math.max(0.22, 1 - absoluteOffset * 0.31);
    }

    if (reduced) {
      scale = Math.max(0.82, 1 - absoluteOffset * 0.08);
      opacity = absoluteOffset <= fadeStart
        ? 1
        : Math.max(0, Math.min(1, (visibilityLimit - absoluteOffset) / fadeDistance));
    }

    return {
      transform:
        'translate3d(calc(-50% + ' + (direction * x).toFixed(2) + 'px), -50%, ' +
        depth.toFixed(2) + 'px) rotateY(' + rotate.toFixed(2) + 'deg) scale(' +
        scale.toFixed(4) + ')',
      opacity: opacity,
      infoOpacity: infoOpacity,
      zIndex: Math.max(1, 100 - Math.round(absoluteOffset * 15)),
      absoluteOffset: absoluteOffset
    };
  };

  CarouselController.prototype.render = function (forceAccessibility) {
    var controller = this;
    var nextActiveIndex;

    if (!this.cards.length) {
      return;
    }

    nextActiveIndex = modulo(Math.round(this.position), this.cards.length);

    this.cards.forEach(function (card, index) {
      var offset = controller.getRelativeOffset(index);
      var state = controller.getCardTransform(offset);
      var absoluteOffset = state.absoluteOffset;

      card.style.transform = state.transform;
      card.style.opacity = String(state.opacity);
      card.style.zIndex = String(state.zIndex);
      card.style.setProperty('--kk-carousel-card-opacity', String(state.opacity));
      card.style.setProperty('--kk-carousel-info-opacity', String(state.infoOpacity));
      card.classList.toggle('is-center', absoluteOffset < 0.48);
      card.classList.toggle('is-side', absoluteOffset >= 0.48 && absoluteOffset < 1.48);
      card.classList.toggle('is-outer', absoluteOffset >= 1.48 && state.opacity > 0.01);
      card.classList.toggle('is-hidden', state.opacity <= 0.01);
    });

    if (forceAccessibility || nextActiveIndex !== this.activeIndex) {
      this.activeIndex = nextActiveIndex;
      this.updateAccessibility(false);
    }
  };

  CarouselController.prototype.updateAccessibility = function (announce) {
    var controller = this;
    var count = this.cards.length;

    this.cards.forEach(function (card, index) {
      var active = index === controller.activeIndex;
      var title = card.querySelector('.productitem--title');
      var label = (controller.itemLabel || 'Tuote') + ' ' + (index + 1) + ' / ' + count;

      if (title && title.textContent.trim()) {
        label += ': ' + title.textContent.trim();
      }

      card.setAttribute('aria-label', label);
      card.setAttribute('aria-hidden', active ? 'false' : 'true');

      card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (element) {
        if (!element.hasAttribute('data-kk-original-tabindex')) {
          element.setAttribute(
            'data-kk-original-tabindex',
            element.hasAttribute('tabindex') ? element.getAttribute('tabindex') : '__none__'
          );
        }

        if (!active) {
          element.setAttribute('tabindex', '-1');
          return;
        }

        var original = element.getAttribute('data-kk-original-tabindex');
        if (original === '__none__') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', original);
        }
      });
    });

    if (announce && this.liveRegion && this.cards[this.activeIndex]) {
      this.liveRegion.textContent = this.cards[this.activeIndex].getAttribute('aria-label');
    }
  };

  CarouselController.prototype.measure = function () {
    var maximumHeight = 0;

    if (!this.cards.length || !this.root.classList.contains('is-carousel-ready')) {
      return;
    }

    this.cards.forEach(function (card) {
      card.style.height = 'auto';
    });

    this.cards.forEach(function (card) {
      maximumHeight = Math.max(maximumHeight, card.scrollHeight, card.getBoundingClientRect().height);
    });

    if (maximumHeight > 0) {
      this.cards.forEach(function (card) {
        card.style.height = Math.ceil(maximumHeight) + 'px';
      });
      this.viewport.style.height = Math.ceil(maximumHeight + (this.mobileView.matches ? 32 : 52)) + 'px';
    }
  };

  CarouselController.prototype.clearEntranceTimer = function () {
    window.clearTimeout(this.entranceTimer);
    this.entranceTimer = null;
  };

  CarouselController.prototype.finishEntrance = function () {
    if (this.entranceComplete) {
      return;
    }

    this.entranceComplete = true;
    this.entranceStarted = true;
    this.root.classList.remove('is-awaiting-entrance');
    this.root.classList.add('has-completed-entrance');
  };

  CarouselController.prototype.resetPendingEntrance = function () {
    if (this.entranceComplete) {
      return;
    }

    this.clearEntranceTimer();
    this.cancelAnimation();
    this.entranceStarted = false;
    this.position = Math.max(0, this.cards.length - 1);
    this.render(true);
  };

  CarouselController.prototype.startEntrance = function () {
    var controller = this;

    if (
      this.destroyed ||
      this.entranceComplete ||
      this.entranceStarted ||
      !this.sectionVisible ||
      document.hidden
    ) {
      return;
    }

    this.entranceStarted = true;
    this.clearAutoTimer();
    this.clearEntranceTimer();
    this.entranceTimer = window.setTimeout(function () {
      controller.entranceTimer = null;

      if (controller.destroyed || !controller.sectionVisible || document.hidden) {
        controller.entranceStarted = false;
        return;
      }

      controller.animateTo(
        controller.cards.length,
        ENTRANCE_DURATION,
        true,
        function () {
          if (controller.destroyed) {
            return;
          }
          controller.finishEntrance();
          controller.scheduleAuto(AUTO_DELAY);
        }
      );
    }, ENTRANCE_DELAY);
  };

  CarouselController.prototype.setupVisibilityObserver = function () {
    var controller = this;

    if (!('IntersectionObserver' in window)) {
      this.sectionVisible = true;
      if (!this.entranceComplete) {
        this.startEntrance();
      } else {
        this.scheduleAuto(AUTO_DELAY);
      }
      return;
    }

    this.visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var isVisible = entry.isIntersecting && entry.intersectionRatio > 0;

        controller.sectionVisible = isVisible;
        controller.root.classList.toggle('is-in-carousel-view', isVisible);
        controller.root.setAttribute(
          'data-kk-motion-paused',
          (!isVisible || document.hidden || controller.reducedMotion.matches) ? 'true' : 'false'
        );

        if (!isVisible) {
          controller.clearAutoTimer();
          if (!controller.entranceComplete) {
            controller.resetPendingEntrance();
          } else {
            controller.pauseActiveAnimation();
          }
          return;
        }

        if (!controller.entranceComplete) {
          controller.startEntrance();
        } else {
          controller.scheduleAuto(INTERACTION_RESUME_DELAY);
        }
      });
    }, {
      threshold: [0, 0.12]
    });

    this.visibilityObserver.observe(this.root);
  };

  CarouselController.prototype.canAutoPlay = function () {
    return (
      !this.destroyed &&
      this.cards.length > 1 &&
      this.sectionVisible &&
      this.entranceComplete &&
      !this.userPaused &&
      !this.focusWithin &&
      !this.dragging &&
      !document.hidden &&
      !this.reducedMotion.matches
    );
  };

  CarouselController.prototype.clearAutoTimer = function () {
    window.clearTimeout(this.autoTimer);
    this.autoTimer = null;
  };

  CarouselController.prototype.scheduleAuto = function (delay) {
    var controller = this;

    this.clearAutoTimer();
    if (!this.canAutoPlay()) {
      return;
    }

    this.autoTimer = window.setTimeout(function () {
      if (!controller.canAutoPlay()) {
        return;
      }
      controller.animateTo(Math.round(controller.position) + 1, AUTO_DURATION, false, function () {
        controller.scheduleAuto(AUTO_DELAY);
      });
    }, typeof delay === 'number' ? delay : AUTO_DELAY);
  };

  CarouselController.prototype.cancelAnimation = function () {
    if (this.animationFrame !== null) {
      window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  };

  CarouselController.prototype.pauseActiveAnimation = function () {
    this.cancelAnimation();
    if (!this.cards.length || this.pointer) {
      return;
    }

    this.dragging = false;
    this.carousel.classList.remove('is-dragging');
    this.position = modulo(Math.round(this.position), this.cards.length);
    this.render(true);
    this.updateAccessibility(false);
  };

  CarouselController.prototype.animateTo = function (target, duration, announce, callback) {
    var controller = this;
    var start = this.position;
    var difference = target - start;
    var startedAt = performance.now();

    this.cancelAnimation();

    if (
      this.reducedMotion.matches ||
      document.hidden ||
      !this.sectionVisible ||
      Math.abs(difference) < 0.001
    ) {
      this.position = modulo(target, this.cards.length);
      this.render(true);
      this.updateAccessibility(announce);
      if (callback) {
        callback();
      }
      return;
    }

    function frame(timestamp) {
      if (
        controller.destroyed ||
        controller.reducedMotion.matches ||
        document.hidden ||
        !controller.sectionVisible
      ) {
        controller.animationFrame = null;
        controller.position = modulo(Math.round(controller.position), controller.cards.length);
        controller.render(true);
        controller.updateAccessibility(false);
        return;
      }

      var progress = clamp((timestamp - startedAt) / duration, 0, 1);
      controller.position = start + difference * easeInOutCubic(progress);
      controller.render(false);

      if (progress < 1 && !controller.destroyed) {
        controller.animationFrame = window.requestAnimationFrame(frame);
        return;
      }

      controller.animationFrame = null;
      controller.position = modulo(target, controller.cards.length);
      controller.render(true);
      controller.updateAccessibility(announce);
      if (callback) {
        callback();
      }
    }

    this.animationFrame = window.requestAnimationFrame(frame);
  };

  CarouselController.prototype.beginInteraction = function () {
    this.clearAutoTimer();
    if (!this.entranceComplete) {
      this.clearEntranceTimer();
      this.cancelAnimation();
      this.position = modulo(Math.round(this.position), this.cards.length);
      this.finishEntrance();
      this.render(true);
      this.updateAccessibility(false);
    }
  };

  CarouselController.prototype.pauseAutoAfterInteraction = function () {
    this.beginInteraction();
    this.userPaused = true;
    this.updateToggle();
  };

  CarouselController.prototype.moveBy = function (amount, announce) {
    var controller = this;
    var target = Math.round(this.position) + amount;

    this.animateTo(target, SNAP_DURATION, announce, function () {
      controller.scheduleAuto(INTERACTION_RESUME_DELAY);
    });
  };

  CarouselController.prototype.onPointerDown = function (event) {
    var now;

    if (
      this.cards.length < 2 ||
      (event.pointerType === 'mouse' && event.button !== 0)
    ) {
      return;
    }

    this.beginInteraction();
    this.cancelAnimation();
    now = performance.now();
    this.pointer = {
      id: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      startPosition: this.position,
      startSnapPosition: Math.round(this.position),
      lastX: event.clientX,
      lastDeltaX: 0,
      maxAbsDeltaX: 0,
      samples: [{
        x: event.clientX,
        time: now
      }],
      horizontal: null,
      moved: false,
      captured: false
    };
  };

  CarouselController.prototype.onPointerMove = function (event) {
    var pointer = this.pointer;
    var deltaX;
    var deltaY;
    var now;
    var distance;
    var nextPosition;
    var absoluteX;
    var absoluteY;

    if (!pointer || pointer.id !== event.pointerId) {
      return;
    }

    deltaX = event.clientX - pointer.startX;
    deltaY = event.clientY - pointer.startY;
    absoluteX = Math.abs(deltaX);
    absoluteY = Math.abs(deltaY);

    if (pointer.horizontal === null) {
      if (Math.max(absoluteX, absoluteY) < POINTER_INTENT_THRESHOLD) {
        return;
      }

      if (
        absoluteX >= POINTER_INTENT_THRESHOLD &&
        absoluteX >= absoluteY * HORIZONTAL_INTENT_RATIO
      ) {
        pointer.horizontal = true;
        pointer.moved = true;
        this.pauseAutoAfterInteraction();
      } else if (
        absoluteY >= VERTICAL_INTENT_THRESHOLD &&
        absoluteY >= absoluteX * VERTICAL_INTENT_RATIO
      ) {
        pointer.horizontal = false;
      } else {
        return;
      }
    }

    if (pointer.horizontal === false) {
      return;
    }

    if (pointer.horizontal !== true) {
      return;
    }

    if (event.cancelable) {
      event.preventDefault();
    }

    distance = Math.max(180, this.viewport.clientWidth * this.getLayoutConfig().firstStepFactor);
    nextPosition = pointer.startPosition - deltaX / distance;
    now = performance.now();
    pointer.lastX = event.clientX;
    pointer.lastDeltaX = deltaX;
    pointer.maxAbsDeltaX = Math.max(pointer.maxAbsDeltaX, absoluteX);
    recordPointerSample(pointer, event.clientX, now);

    if (!pointer.captured) {
      try {
        this.viewport.setPointerCapture(event.pointerId);
        pointer.captured = true;
      } catch (error) {
        /* Pointer capture is an enhancement; dragging still works without it. */
      }
    }

    this.dragging = pointer.moved;
    this.carousel.classList.toggle('is-dragging', this.dragging);
    this.position = nextPosition;
    this.render(false);
  };

  CarouselController.prototype.onPointerEnd = function (event, cancelled) {
    var pointer = this.pointer;
    var target;
    var controller = this;
    var endX;
    var deltaX;
    var velocity;
    var threshold;
    var directionSource;
    var direction;
    var effectiveDistance;
    var qualifiesAsSwipe;
    var stepDistance;
    var swipeSteps;
    var snapDuration;

    if (!pointer || pointer.id !== event.pointerId) {
      return;
    }

    if (pointer.captured) {
      try {
        this.viewport.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* The pointer may already have been released by the browser. */
      }
    }

    this.pointer = null;
    this.carousel.classList.remove('is-dragging');

    if (pointer.horizontal === true && pointer.moved) {
      endX = cancelled
        ? pointer.lastX
        : (typeof event.clientX === 'number' ? event.clientX : pointer.lastX);

      if (!cancelled) {
        recordPointerSample(pointer, endX, performance.now());
      }

      deltaX = endX - pointer.startX;
      if (Math.abs(pointer.lastDeltaX) > Math.abs(deltaX)) {
        deltaX = pointer.lastDeltaX;
      }

      velocity = cancelled ? 0 : getPointerVelocity(pointer);
      threshold = clamp(this.viewport.clientWidth * 0.13, SWIPE_DISTANCE_MIN, SWIPE_DISTANCE_MAX);
      effectiveDistance = Math.max(Math.abs(deltaX), pointer.maxAbsDeltaX);
      qualifiesAsSwipe = (
        effectiveDistance >= threshold ||
        (!cancelled && Math.abs(velocity) >= FLICK_VELOCITY)
      );
      directionSource = Math.abs(deltaX) >= POINTER_INTENT_THRESHOLD
        ? deltaX
        : (pointer.lastDeltaX || velocity);
      direction = directionSource < 0 ? 1 : -1;
      stepDistance = Math.max(
        180,
        this.viewport.clientWidth * this.getLayoutConfig().firstStepFactor
      );
      swipeSteps = qualifiesAsSwipe
        ? clamp(
            Math.max(1, Math.round(effectiveDistance / stepDistance)),
            1,
            this.cards.length - 1
          )
        : 0;
      snapDuration = SNAP_DURATION + Math.max(0, swipeSteps - 1) * 90;
      target = qualifiesAsSwipe
        ? pointer.startSnapPosition + direction * swipeSteps
        : pointer.startSnapPosition;

      this.suppressClickUntil = Date.now() + 450;
      this.animateTo(target, snapDuration, true, function () {
        controller.dragging = false;
        if (document.activeElement === controller.viewport) {
          controller.viewport.blur();
        }
        controller.scheduleAuto(INTERACTION_RESUME_DELAY);
      });
      return;
    }

    this.dragging = false;
    this.animateTo(Math.round(this.position), 260, false, function () {
      controller.scheduleAuto(INTERACTION_RESUME_DELAY);
    });
  };

  CarouselController.prototype.onClick = function (event) {
    var card = event.target.closest(CARD_SELECTOR);
    var cardIndex;
    var cardOffset;
    var clickedLink;
    var interactiveElement;
    var productLink;
    var controller = this;

    if (!card || !this.root.contains(card)) {
      return;
    }

    if (Date.now() < this.suppressClickUntil) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.pauseAutoAfterInteraction();
    cardIndex = this.cards.indexOf(card);

    if (cardIndex !== -1 && cardIndex !== this.activeIndex) {
      event.preventDefault();
      event.stopPropagation();
      this.cancelAnimation();
      cardOffset = this.getRelativeOffset(cardIndex);
      this.animateTo(this.position + cardOffset, SNAP_DURATION, true, function () {
        controller.scheduleAuto(INTERACTION_RESUME_DELAY);
      });
      return;
    }

    clickedLink = event.target.closest('a[href]');

    if (clickedLink && card.contains(clickedLink)) {
      return;
    }

    interactiveElement = event.target.closest('button, input, select, textarea, [role="button"]');

    if (interactiveElement && card.contains(interactiveElement)) {
      return;
    }

    productLink = card.querySelector('a[data-product-page-link][href], a[href]');

    if (
      productLink &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    ) {
      window.location.assign(productLink.href);
    }
  };

  CarouselController.prototype.updateToggle = function () {
    var paused;
    var label;

    if (!this.toggle) {
      return;
    }

    this.toggle.hidden = this.cards.length < 2 || this.reducedMotion.matches;
    paused = this.userPaused;
    label = paused
      ? (this.playLabel || 'Käynnistä automaattinen kierto')
      : (this.pauseLabel || 'Pysäytä automaattinen kierto');

    this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    this.toggle.setAttribute('aria-label', label);
    if (this.toggleLabel) {
      this.toggleLabel.textContent = label;
    }
  };

  CarouselController.prototype.refresh = function (preserveCard) {
    var previousCard = preserveCard || this.cards[this.activeIndex] || null;
    var previousIndex;

    this.cards = sortCards(this.root);
    if (!this.entranceComplete) {
      this.resetPendingEntrance();
      this.position = Math.max(0, this.cards.length - 1);
    } else {
      previousIndex = previousCard ? this.cards.indexOf(previousCard) : -1;
      this.position = previousIndex >= 0
        ? previousIndex
        : clamp(this.activeIndex, 0, Math.max(0, this.cards.length - 1));
    }
    this.activeIndex = -1;
    this.updateToggle();
    this.measure();
    this.render(true);
    if (!this.entranceComplete) {
      this.startEntrance();
    } else {
      this.scheduleAuto(INTERACTION_RESUME_DELAY);
    }
  };

  CarouselController.prototype.destroy = function () {
    this.destroyed = true;
    this.clearAutoTimer();
    this.clearEntranceTimer();
    this.cancelAnimation();
    window.clearTimeout(this.resizeTimer);
    if (this.visibilityObserver) {
      this.visibilityObserver.disconnect();
      this.visibilityObserver = null;
    }

    this.cleanup.forEach(function (removeListener) {
      removeListener();
    });
    this.cleanup = [];

    this.cards.forEach(function (card) {
      card.removeAttribute('style');
      card.removeAttribute('role');
      card.removeAttribute('aria-roledescription');
      card.removeAttribute('aria-label');
      card.removeAttribute('aria-hidden');
      card.classList.remove('is-center', 'is-side', 'is-outer', 'is-hidden');
      card.querySelectorAll('[data-kk-original-tabindex]').forEach(function (element) {
        var original = element.getAttribute('data-kk-original-tabindex');
        if (original === '__none__') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', original);
        }
        element.removeAttribute('data-kk-original-tabindex');
      });
    });

    this.viewport.removeAttribute('style');
    this.root.classList.remove(
      'is-carousel-ready',
      'is-awaiting-entrance',
      'has-completed-entrance',
      'is-in-carousel-view'
    );
    this.root.removeAttribute('data-kk-upcoming-initialized');
    this.root.removeAttribute('data-kk-motion-paused');
    this.carousel.removeAttribute('data-kk-upcoming-carousel-initialized');
  };

  function initializeRoot(root) {
    var existing = controllers.get(root);
    var controller;

    if (existing) {
      existing.refresh();
      return;
    }

    controller = new CarouselController(root);
    if (controller.init()) {
      controllers.set(root, controller);
    }
  }

  function findRoots(scope) {
    var roots = [];

    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR)));
    }

    return roots;
  }

  function initializeAll(scope) {
    findRoots(scope || document).forEach(initializeRoot);
  }

  function destroyWithin(scope) {
    findRoots(scope || document).forEach(function (root) {
      var controller = controllers.get(root);
      if (controller) {
        controller.destroy();
        controllers.delete(root);
      }
    });
  }

  if (window[RUNTIME_KEY]) {
    window[RUNTIME_KEY].initializeAll(document);
    return;
  }

  window[RUNTIME_KEY] = {
    initializeAll: initializeAll,
    destroyWithin: destroyWithin
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
}());
